/* tslint:disable */
/* eslint-disable */
/**
 * Melco Fusion APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FusionMelcoFusionModelsFusionConfiguratorSetting
 */
export interface FusionMelcoFusionModelsFusionConfiguratorSetting {
    /**
     * 
     * @type {number}
     * @memberof FusionMelcoFusionModelsFusionConfiguratorSetting
     */
    version?: number;
}

export function FusionMelcoFusionModelsFusionConfiguratorSettingFromJSON(json: any): FusionMelcoFusionModelsFusionConfiguratorSetting {
    return FusionMelcoFusionModelsFusionConfiguratorSettingFromJSONTyped(json, false);
}

export function FusionMelcoFusionModelsFusionConfiguratorSettingFromJSONTyped(json: any, ignoreDiscriminator: boolean): FusionMelcoFusionModelsFusionConfiguratorSetting {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'version': !exists(json, 'version') ? undefined : json['version'],
    };
}

export function FusionMelcoFusionModelsFusionConfiguratorSettingToJSON(value?: FusionMelcoFusionModelsFusionConfiguratorSetting | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'version': value.version,
    };
}


